import React from 'react';
import PropTypes from 'prop-types';

const ContasRow = (props) => {
    return (
        <tr>
            <td>{props.conta.nome}</td>
            <td>
                <a href="#" onClick={() => props.handleUpdate(props.conta)} >
                    <i className="far fa-edit" style={{ cursor: "pointer" }} title={"Alterar id: " + props.conta.id} />
                </a>
                {" | "}
                <a href="#" onClick={() => props.handleDelete(props.conta.id)} >
                    <i className="far fa-trash-alt" style={{ cursor: "pointer" }}  title={"Deletar id: " + props.conta.id}/>
                </a>
            </td>
        </tr>
    );
};

ContasRow.propTypes = {
    conta: PropTypes.object.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
};

export default ContasRow;


// WEBPACK FOOTER //
// ./src/components/contas/ContasRow.js